<template>
  <svg class="icon o-icon" :class="sizeClass">
    <use v-bind="{ 'xlink:href': xlink }"></use>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    xlink() {
      return `#icon-${this.icon}`
    },
    sizeClass() {
      if (this.small) {
        return "o-icon--small icon--small"
      } else if (this.large) {
        return "o-icon--large icon--large"
      }

      return ""
    }
  }
}
</script>